import React from "react";
import {Checkbox} from '@fluentui/react';
import TemplHoverCard from '../../formFields/TemplHoverCard';

class TemplateItem extends React.Component {

    pickTemplate()
    {
        this.props.pick(this.props.id);
    } 

    render() {
        //const imgTeamSite = "https://spoprod-a.akamaihd.net/files/odsp-next-prod_2019-05-31-sts_20190605.001/odsp-media/images/designpackage/teamsite.png";
        //const imgCommSite = "https://spoprod-a.akamaihd.net/files/odsp-next-prod_2019-05-31-sts_20190605.001/odsp-media/images/designpackage/reportsite.png";
               
        // const templStyle = this.props.type.toLowerCase() === SiteType.customSite_display.toLowerCase() ? {backgroundColor: '#F4F4F4'}: {backgroundColor: 'white'};
        const templBody =
            <div>
                <span style={{fontSize: '1em', fontWeight: 'bold', display: 'flex'}}>
                    {this.props.name} 
                    <TemplHoverCard 
                        pickTemplate={this.pickTemplate.bind(this)} 
                        id={this.props.id} 
                        selected={this.props.selected} 
                        name={this.props.name}
                        description={this.props.description}
                        imageUrl={this.props.imageUrl} />                    
                </span>
                <img src={this.props.imageUrl} style={TemplateImageStyles} alt='Template'></img>
            </div> 
            
        return (
            <div className={this.props.class} onClick={this.pickTemplate.bind(this)} >
                <div className='template-title'>
                    {templBody}
                    <div className="template-checkbox"><Checkbox className="checkbox-template" styles={{checkbox: {margin: 0}}} checked={this.props.selected}/></div>
                </div>
            </div> 
        );
    }
}


const TemplateImageStyles = {
    maxHeight:'65%', 
    maxWidth:'80%', 
    position: 'absolute', 
    top: '55px', 
    left:'10px'
}


export default TemplateItem






// WEBPACK FOOTER //
// ./src/components/CreateSite/Step1/TemplateItem.js